<template>
  <div class="candy-finance">
    <Card>
      <div class="filter-row">
        <span>统计日期</span>
        <DatePicker v-model="searchDate" type="daterange" placement="bottom-start"
          placeholder="默认今天" style="width: 230px" />
        <Button type="primary" :loading="loading" @click="loadData">查询</Button>
        <Button :loading="loading" @click="loadData">刷新</Button>
        <span class="refresh-note">实时数据每 30 秒自动刷新，最近刷新：{{ fetchedAt || "暂无" }}</span>
      </div>
    </Card>

    <Card class="section">
      <div slot="title">实时大盘 <span class="title-note">不受日期筛选影响；正数为平台盈利，负数为平台亏损</span></div>
      <Row :gutter="16">
        <Col :span="6"><div class="metric"><div>累计大盘盈亏</div><strong :class="netClass(live.closingNet)">{{ amount(live.closingNet) }}</strong><small>币</small></div></Col>
        <Col :span="6"><div class="metric"><div>进行中游戏点数待兑</div><strong>{{ amount(live.pendingCoins) }}</strong><small>币</small></div></Col>
        <Col :span="6"><div class="metric"><div>出奖计算大盘</div><strong :class="netClass(live.effectiveNet)">{{ amount(live.effectiveNet) }}</strong><small>币</small></div></Col>
        <Col :span="6"><div class="metric"><div>进行中场次</div><strong>{{ live.activeGames || 0 }}</strong><small>场</small></div></Col>
      </Row>
      <div class="live-extra">
        今日投币 {{ amount(live.todayBet) }} 币 · 今日兑回 {{ amount(live.todayPayout) }} 币 ·
        今日净收益 <span :class="netClass(live.todayNet)">{{ amount(live.todayNet) }}</span> 币 ·
        投币 {{ live.coinCount || 0 }} 次 · 开奖 {{ live.roundCount || 0 }} 局 ·
        大盘更新 {{ live.updatedAt || "暂无" }}
      </div>
    </Card>

    <Card class="section">
      <div slot="title">每日大盘 <span class="title-note">{{ range.starttime }} 至 {{ range.endtime }}</span></div>
      <div class="range-summary">
        筛选期投币 <b>{{ amount(range.betAmount) }}</b> 币，
        兑回 <b>{{ amount(range.payoutAmount) }}</b> 币，
        净收益 <b :class="netClass(range.profit)">{{ amount(range.profit) }}</b> 币
      </div>
      <Table border :loading="loading" :columns="dailyColumns" :data="daily" />
    </Card>

    <Card class="section">
      <div slot="title">虚拟糖果房间账 <span class="title-note">参考推币机账，按房间汇总</span></div>
      <Table border :loading="loading" :columns="roomColumns" :data="rooms" />
      <p class="accounting-note">房间账按游戏开局日期归属整场投币和兑回；每日大盘按实际投币、结算日期入账。跨日游戏会使两张表在单日的金额不同。</p>
    </Card>
  </div>
</template>

<script>
import { candylist } from "../../api/finance";

const amountColumn = (title, key) => ({
  title, key, sortable: true,
  render: (h, params) => h("span", Number(params.row[key] || 0).toFixed(2)),
});

export default {
  name: "CandyFinance",
  data() {
    return {
      searchDate: [],
      loading: false,
      fetchedAt: "",
      timer: null,
      live: {},
      range: {},
      daily: [],
      rooms: [],
      dailyColumns: [
        { title: "日期", key: "date", sortable: true },
        amountColumn("期初大盘", "openingNet"),
        amountColumn("投币", "betAmount"),
        amountColumn("兑回", "payoutAmount"),
        amountColumn("当日净收益", "dailyNet"),
        amountColumn("期末大盘", "closingNet"),
        { title: "投币次数", key: "coinCount", sortable: true },
        { title: "开奖局数", key: "roundCount", sortable: true },
      ],
      roomColumns: [
        { title: "房间 ID", key: "roomid", sortable: true },
        { title: "房间名称", key: "roomname" },
        { title: "游戏场次", key: "gameCount", sortable: true },
        amountColumn("投币币数", "betAmount"),
        amountColumn("兑回币数", "payoutAmount"),
        amountColumn("净收益", "profit"),
        {
          title: "收益率", key: "profitRate", sortable: true,
          render: (h, params) => h("span", `${Number(params.row.profitRate || 0).toFixed(2)}%`),
        },
      ],
    };
  },
  mounted() {
    this.loadData();
    this.timer = setInterval(() => this.loadData(), 30000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    amount(value) {
      return Number(value || 0).toFixed(2);
    },
    netClass(value) {
      return Number(value || 0) < 0 ? "negative" : "positive";
    },
    formatDate(value) {
      const year = value.getFullYear();
      const month = String(value.getMonth() + 1).padStart(2, "0");
      const day = String(value.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    async loadData() {
      if (this.loading) return;
      const selected = this.searchDate || [];
      const starttime = selected[0] instanceof Date && !isNaN(selected[0])
        ? this.formatDate(selected[0]) : "";
      const endtime = selected[1] instanceof Date && !isNaN(selected[1])
        ? this.formatDate(selected[1]) : "";
      if (!!starttime !== !!endtime) {
        this.$Message.warning("请选择完整的日期范围");
        return;
      }
      this.loading = true;
      try {
        const response = await candylist({ starttime, endtime });
        const result = response.data || {};
        this.live = result.live || {};
        this.range = result.range || {};
        this.daily = result.daily || [];
        this.rooms = result.rooms || [];
        this.fetchedAt = new Date().toLocaleTimeString();
      } catch (error) {
        // 公共请求拦截器负责显示业务错误。
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.candy-finance { padding: 16px; }
.section { margin-top: 16px; }
.filter-row { display: flex; align-items: center; gap: 12px; }
.refresh-note, .title-note, .accounting-note { color: #808695; font-size: 12px; font-weight: normal; }
.refresh-note { margin-left: auto; }
.title-note { margin-left: 12px; }
.metric { padding: 12px 16px; min-height: 88px; background: #f8f8f9; border-radius: 4px; }
.metric strong { display: inline-block; margin-top: 8px; font-size: 26px; line-height: 30px; }
.metric small { margin-left: 6px; }
.negative { color: #ed4014; }
.positive { color: #19be6b; }
.live-extra, .range-summary { padding: 16px 0 4px; }
.range-summary { padding-top: 0; padding-bottom: 12px; }
.accounting-note { margin-top: 12px; }
</style>
